/**
 * @file コンポーネント：フル動画ページ機器広告コンテンツ スタイル管理
 */

// ライブラリ読み込み
import styled from "styled-components";

// スタイル
export const StyledContents = styled.div``;
